import React, { Component } from 'react';
import ApiParametersCreatorComponent from './ApiParametersCreatorComponent';
import ApiParametersListComponent from './ApiParametersListComponent';

class ApiParametersComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    return (
      <div className={'flex flex-col w-full h-full pt-4'}>
          <ApiParametersCreatorComponent />
          <ApiParametersListComponent />
      </div>
    );
  }
}

interface Props {}

class State {}

export default ApiParametersComponent;
